import { isConvertibleToNumber } from "~/utils/isConvertibleToNumber";

interface FormatPercentOptions {
  locale?: string;
  precision?: number;
  showPositivePrefix?: boolean;
}

/**
 * Function to format a number as a percentage
 *
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/NumberFormat
 *
 * @param {number|string} value - value to be formatted
 * @param {FormatPercentOptions} options - formatting options
 * @returns {string | undefined} - value formatted as percent
 */
export const formatPercent = (
  value: number | string,
  options: FormatPercentOptions = {},
): string | undefined => {
  if (!isConvertibleToNumber(value)) {
    return undefined;
  }

  const percentValue = Number(value);
  const { locale = "de-DE", precision = 2, showPositivePrefix = false } = options;

  const formatter = new Intl.NumberFormat(locale, {
    style: "percent",
    minimumFractionDigits: precision,
    maximumFractionDigits: precision,
  });

  return `${showPositivePrefix && percentValue > 0 ? "+" : ""}${formatter.format(
    percentValue / 100,
  )}`;
};
